import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDebounce } from "use-debounce";
import {
  Table,
  TableBody,
  TableFilter,
  TableHeader,
  TablePagination,
  TableSearch,
} from "../../../components/table";
import http from "../../../config/BaseUrl";
import useTimeFormate from "../../../hook/useTimeFormat";

function DataCaptureTable({ viewRouteBase = "/data-capture-view" }) {
  const { formateLocalTime } = useTimeFormate();
  const [loading, setLoading] = useState(false);
  const [dataCapture, setDataCapture] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [searchKeyWordDebounce] = useDebounce(searchKeyWord, 1000);

  const handleSearch = (query) => {
    setSearchKeyWord(query);
    setCurrentPage(1);
  };

  const fetchDataCapture = async (params) => {
    try {
      setLoading(true);
      await http
        .get("data-capture/events", { params })
        .then((res) => {
          if (res) {
            setDataCapture(res.data.events);
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    } catch (error) {}
  };

  useEffect(() => {
    const params = {
      page: currentPage,
      search: searchKeyWordDebounce,
    };
    fetchDataCapture(params);
  }, [currentPage, searchKeyWordDebounce]);

  return (
    <div className="data-capture-table">
      <TableFilter>
        <TableSearch
          value={searchKeyWord}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </TableFilter>
      <Table>
        <TableHeader>
          <tr className="p-3">
            <th>Event</th>
            <th>Venue</th>
            <th>Start Date &amp; Time</th>
            <th>End Date &amp; Time</th>
            <th>Captured Leads</th>
            <th className="text-center">Action</th>
          </tr>
        </TableHeader>
        <TableBody>
          {loading ? (
            <tr>
              <td colSpan={7}>
                <div className="my-5 text-center col-md-12">
                  <span
                    className="spinner-border"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </div>
              </td>
            </tr>
          ) : (
            dataCapture.data &&
            dataCapture.data.map((item) => {
              const viewPath = `${viewRouteBase}/${item.id}`;

              return (
                <tr key={item.id}>
                  <td>{item.event_name}</td>
                  <td>{item.venue_name}</td>
                  <td>{formateLocalTime(item.event_start_date)}</td>
                  <td>{formateLocalTime(item.event_end_date)}</td>
                  <td>{item.data_capture_count}</td>
                  <td className="text-center">
                    {item.data_capture_count > 0 ? (
                      <Link
                        to={{
                          pathname: viewPath,
                          state: item,
                        }}
                        className="m-1 btn btn-outline-secondary radius-30 btn-sm btn-block"
                      >
                        View
                      </Link>
                    ) : (
                      <Link
                        to={viewPath}
                        className="m-1 btn btn-outline-secondary radius-30 btn-sm btn-block disabled "
                      >
                        View
                      </Link>
                    )}
                  </td>
                </tr>
              );
            })
          )}
        </TableBody>
      </Table>
      <TablePagination
        currentPage={dataCapture.current_page}
        total={dataCapture.total}
        perPage={5}
        from={dataCapture.from}
        to={dataCapture.to}
        onChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
}

export default DataCaptureTable;
